import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import EconomicCalenderListDisplay from './EconomicCalenderListDisplay';

class EconomicCalenderWrap extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Economic Calender</title>
          <link rel="canonical" href="https://www.vizfm.com/economicCalender" />
          <meta name="description" content="Economic Calender for Investors and Traders" />
        </Helmet>
        <Container fluid className="p-2">
          <Row><Col>Economic Events Calender</Col></Row>
          <Row>
            <Col><EconomicCalenderListDisplay limt={100}/></Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default EconomicCalenderWrap;
